import { Component, type ErrorInfo, type ReactNode } from "react";

type State = { error: Error | null };

export class RootErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[RootErrorBoundary]", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            padding: "32px",
            maxWidth: "720px",
            margin: "40px auto",
            fontFamily: "system-ui, sans-serif",
            color: "#F8FAFC",
            background: "#11172A",
            border: "1px solid #1F2A44",
            borderRadius: "12px",
          }}
        >
          <h1 style={{ margin: 0, fontSize: "1.25rem", fontWeight: 600 }}>
            Something broke at startup.
          </h1>
          <p style={{ color: "#A3AEC4", marginTop: 8 }}>
            Open DevTools (F12) → Console for the full stack trace and share it.
          </p>
          <pre
            style={{
              marginTop: 16,
              padding: 16,
              background: "#0B0F1A",
              borderRadius: 8,
              fontSize: 12,
              lineHeight: 1.5,
              overflow: "auto",
              maxHeight: 320,
              whiteSpace: "pre-wrap",
              color: "#F87171",
            }}
          >
            {this.state.error.name}: {this.state.error.message}
            {"\n\n"}
            {this.state.error.stack}
          </pre>
          <button
            type="button"
            onClick={() => {
              this.setState({ error: null });
              window.location.reload();
            }}
            style={{
              marginTop: 16,
              padding: "8px 16px",
              borderRadius: 8,
              background: "#818CF8",
              color: "#0B0F1A",
              border: 0,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
